export const configHomeContentBlockWOTY = {
  heading: "Women of the Year 2025",
  description:
    "Since 1960, <i>Her World</i> has celebrated outstanding Singaporean women. Its <b>Woman of the Year</b> and <b>Young Woman Achiever</b> awards honour trailblazers and rising leaders who break boundaries, inspire change, and shape the future — continuing <i>Her World</i>'s legacy of recognising women who drive progress in their fields and communities.",
  viewMore: {
    text: "Read More",
  },
  landscapeImageWidth: 315,
  portraitImageWidth: 315,
};
